'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeMatterRestrictionIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeMatterRestrictionIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_271_61426)">
          <path
            d="M3.57227 7.14314C3.57227 6.00649 4.0238 4.91641 4.82752 4.11268C5.63125 3.30895 6.72134 2.85742 7.85798 2.85742H32.1437C33.2803 2.85742 34.3704 3.30895 35.1742 4.11268C35.9779 4.91641 36.4294 6.00649 36.4294 7.14314V35.7146C36.4294 36.2774 36.3186 36.8347 36.1032 37.3546C35.8878 37.8746 35.5721 38.3471 35.1742 38.745C34.7762 39.143 34.3037 39.4587 33.7838 39.674C33.2638 39.8894 32.7065 40.0003 32.1437 40.0003H7.85798C6.72134 40.0003 5.63125 39.5487 4.82752 38.745C4.0238 37.9413 3.57227 36.8512 3.57227 35.7146V7.14314Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7148 0C15.3396 0 14.9681 0.0739022 14.6215 0.217487C14.2748 0.361072 13.9599 0.571528 13.6945 0.836838C13.4292 1.10215 13.2188 1.41712 13.0752 1.76376C12.9316 2.11041 12.8577 2.48194 12.8577 2.85714V4.28571C12.8577 4.66092 12.9316 5.03245 13.0752 5.3791C13.2188 5.72574 13.4292 6.04071 13.6945 6.30602C13.9599 6.57133 14.2748 6.78179 14.6215 6.92537C14.9681 7.06895 15.3396 7.14286 15.7148 7.14286H24.2863C25.044 7.14286 25.7708 6.84184 26.3066 6.30602C26.8424 5.7702 27.1434 5.04348 27.1434 4.28571V2.85714C27.1434 2.09938 26.8424 1.37266 26.3066 0.836838C25.7708 0.30102 25.044 0 24.2863 0H15.7148ZM12.8577 22.1429C12.2894 22.1429 11.7443 22.3686 11.3425 22.7705C10.9406 23.1723 10.7148 23.7174 10.7148 24.2857C10.7148 24.854 10.9406 25.3991 11.3425 25.8009C11.7443 26.2028 12.2894 26.4286 12.8577 26.4286H27.1434C27.7117 26.4286 28.2568 26.2028 28.6586 25.8009C29.0605 25.3991 29.2863 24.854 29.2863 24.2857C29.2863 23.7174 29.0605 23.1723 28.6586 22.7705C28.2568 22.3686 27.7117 22.1429 27.1434 22.1429H12.8577Z"
            fill="#3D517B"
          />
          <g clipPath="url(#clip1_271_61426)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.00048 0.130859C2.31477 0.130859 0.134766 2.31372 0.134766 5.00229V34.9966C0.134766 37.688 2.31477 39.868 5.00619 39.868H35.0005C37.6919 39.868 39.8719 37.688 39.8719 34.9966V5.00229C39.8719 2.31086 37.6919 0.130859 35.0005 0.130859H5.00334H5.00048Z"
              fill="#D8DCE5"
            />
            <path
              d="M5.00048 0.130859C2.31477 0.130859 0.134766 2.31372 0.134766 5.00229V9.99943H39.8719V4.99943C39.8719 2.31372 37.6919 0.130859 35.0005 0.130859H5.00334H5.00048Z"
              fill="#3D517B"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.7091 24.9937C30.7091 22.1536 29.5809 19.4299 27.5727 17.4216C25.5644 15.4134 22.8406 14.2852 20.0006 14.2852C17.1834 14.2852 14.4177 15.4223 12.4234 17.4166C11.1795 18.6621 10.2619 20.1951 9.75166 21.8799C9.24145 23.5646 9.15443 25.3492 9.49831 27.0756C9.84218 28.8019 10.6063 30.4169 11.7232 31.7776C12.84 33.1383 14.275 34.2026 15.9012 34.8765C17.5274 35.5504 19.2947 35.813 21.0466 35.641C22.7985 35.4691 24.481 34.8679 25.9451 33.8907C27.4093 32.9135 28.61 31.5905 29.4409 30.0386C30.2719 28.4868 30.7075 26.754 30.7091 24.9937ZM26.4234 24.9937C26.4242 23.9083 26.1498 22.8404 25.6261 21.8898C25.1023 20.9391 24.3461 20.1367 23.4282 19.5574C22.5102 18.9782 21.4605 18.641 20.3769 18.5774C19.2934 18.5138 18.2114 18.7259 17.232 19.1937L25.8006 27.7652C26.2132 26.8997 26.426 25.9525 26.4234 24.9937ZM22.7663 30.7937L14.2063 22.228C13.6328 23.4268 13.4453 24.774 13.6696 26.0838C13.8939 27.3936 14.519 28.6017 15.4587 29.5413C16.3983 30.481 17.6064 31.1061 18.9162 31.3304C20.226 31.5547 21.5732 31.3672 22.772 30.7937H22.7663Z"
              fill="#3D517B"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_271_61426">
            <rect width="40" height="40" fill="white" />
          </clipPath>
          <clipPath id="clip1_271_61426">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeMatterRestrictionIcon.propTypes = {
  sx: PropTypes.object
}
